/**
 * @generated SignedSource<<7bbea13249138b8e75d33848d614f1d5>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { InlineFragment, ReaderInlineDataFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type checkoutRelayAction_item$data = {
  readonly " $fragmentSpreads": FragmentRefs<"checkoutTransactionReducer_item">;
  readonly " $fragmentType": "checkoutRelayAction_item";
};
export type checkoutRelayAction_item$key = {
  readonly " $data"?: checkoutRelayAction_item$data;
  readonly " $fragmentSpreads": FragmentRefs<"checkoutRelayAction_item">;
};

const node: ReaderInlineDataFragment = {
  "kind": "InlineDataFragment",
  "name": "checkoutRelayAction_item"
};

(node as any).hash = "72373aa8a31335ae8927eb8472d6e1c0";

export default node;
